import apiClient from './apiClient';

export const CART_UPDATED_EVENT = 'yubu-cart-updated';

function emitCartUpdated(cart = null) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CART_UPDATED_EVENT, { detail: { cart } }));
}

export function normalizeCart(cart = {}) {
  const items = Array.isArray(cart.items) ? cart.items : [];
  const groupedShops = Array.isArray(cart.grouped_shops)
    ? cart.grouped_shops
    : Array.isArray(cart.groupedShops)
      ? cart.groupedShops
      : [];

  return {
    id: cart.id,
    status: cart.status || 'active',
    totalItems: Number(cart.total_items ?? cart.totalItems ?? 0) || 0,
    subtotal: Number(cart.subtotal) || 0,
    groupedShops: groupedShops.map((group) => ({
      shopId: String(group.shop_id ?? group.shopId ?? ''),
      shopName: group.shop_name || group.shopName || 'Shop',
      shopLocation: group.shop_location || group.shopLocation || '',
      shopZone: group.shop_zone || group.shopZone || '',
      shopAddress: group.shop_address || group.shopAddress || '',
      subtotal: Number(group.subtotal) || 0,
      items: Array.isArray(group.items) ? group.items.map(normalizeCartItem) : [],
    })),
    items: items.map(normalizeCartItem),
  };
}

function normalizeCartItem(item = {}) {
  const stock = item.stock || item.product || {};
  const shop = item.shop || {};

  return {
    id: item.id ? String(item.id) : '',
    bundleSaleId: item.bundle_sale_id || null,
    bundleRevision: item.bundle_revision || null,
    bundleName: item.bundle_name || null,
    bundleCode: item.bundle_code || null,
    bundleAvailable: item.bundle_available,
    originalPrice: Number(item.original_price ?? item.price) || 0,
    stockId: String(item.stock_id ?? item.stockId ?? stock.id ?? ''),
    slug: item.slug || null,
    productName:
      item.product_name ||
      item.productName ||
      stock.name ||
      stock.product_name ||
      'Unnamed Product',
    imageUrl: item.image_url || item.imageUrl || stock.image_url || stock.imageUrl || null,
    price: Number(item.price ?? item.unit_price ?? item.unitPrice ?? stock.price) || 0,
    price_type: item.price_type || 'price_per_item',
    quantity: Number(item.quantity) || 1,
    availableQuantity: Number(item.available_quantity ?? item.availableQuantity ?? 0) || 0,
    shopId: String(item.shop_id ?? item.shopId ?? shop.id ?? stock.shop_id ?? stock.shopId ?? ''),
    shopName: item.shop_name || item.shopName || shop.name || 'Shop',
    shopLocation: item.shop_location || item.shopLocation || shop.location || '',
    shopZone: item.shop_zone || item.shopZone || shop.zone || '',
    shopAddress: item.shop_address || item.shopAddress || shop.address || '',
  };
}

export async function getCart(options = {}) {
  const cart = normalizeCart(await apiClient.get('/buyer/cart', options));
  emitCartUpdated(cart);
  return cart;
}

export async function addCartItem(stockId, quantity = 1) {
  const cart = normalizeCart(
    await apiClient.post('/buyer/cart/items', { stock_id: stockId, quantity })
  );
  emitCartUpdated(cart);
  return cart;
}

export async function updateCartItemQuantity(cartItemId, quantity) {
  const cart = normalizeCart(
    await apiClient.patch(`/buyer/cart/items/${cartItemId}`, { quantity })
  );
  emitCartUpdated(cart);
  return cart;
}

export async function removeCartItem(cartItemId) {
  const cart = normalizeCart(await apiClient.delete(`/buyer/cart/items/${cartItemId}`));
  emitCartUpdated(cart);
  return cart;
}

export async function clearCartShop(shopId) {
  const cart = normalizeCart(await apiClient.delete(`/buyer/cart/shops/${shopId}`));
  emitCartUpdated(cart);
  return cart;
}

export async function addCartBundle(bundleSaleId) {
  const cart = normalizeCart(
    await apiClient.post('/buyer/cart/bundles', { bundle_sale_id: bundleSaleId })
  );
  emitCartUpdated(cart);
  return cart;
}
